import React from 'react';
import { ITitleTextAsProps } from '../../../../../sp-types/routeDetailsType';

export const RouteDetailsTextBox: React.FC<ITitleTextAsProps> = ({ text, title }) => {
  return (
    <div className="p-2 border border-gray-150 rounded-md leading-4">
      <span className="">{title}</span>
      <span className="text-sm text-secondary">{text}</span>
    </div>
  );
};
